import type { FacilityWithCoordinates, MctProvider } from ".";

export function isMctProvider(value: unknown): value is MctProvider {
  const obj = value as Record<string, unknown>;
  return (
    typeof obj.npi === "string" &&
    typeof obj.firstName === "string" &&
    typeof obj.lastName === "string" &&
    typeof obj.credentials === "string" &&
    typeof obj.specialties === "string" &&
    Array.isArray(obj.locations)
  );
}

export function isFacilityWithCoordinates(
  value: unknown
): value is FacilityWithCoordinates {
  const obj = value as Record<string, unknown>;
  return (
    typeof obj.npi === "string" &&
    typeof obj.name === "string" &&
    Array.isArray(obj.specialties) &&
    typeof obj.latitude === "number" &&
    typeof obj.longitude === "number" &&
    Array.isArray(obj.locations)
  );
}
